var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7c878e;\n        stroke: #7c878e;\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.91,32.96l.09-.48-145.49,3.96h-.38v114.2h-14.13v16.88h155.9v-16.88h-14.38l-.16-21.61,18.54-96.08Zm-7.94,130.62H23.94v-9h148.02v9Zm-93.39-12.94h-31.3V54.52h31.3v96.12Zm3.94,0V50.58h-39.18v100.06h-5.27V40.28l137.13-3.74-17.74,92.13.13,21.97h-75.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.44,85.11h8.97c4.56,0,8.27-3.71,8.27-8.27v-7.58c0-4.56-3.71-8.27-8.27-8.27h-8.97c-4.56,0-8.27,3.71-8.27,8.27v7.58c0,4.56,3.71,8.27,8.27,8.27Zm0-20.67h8.97c2.66,0,4.82,2.16,4.82,4.82v7.58c0,2.66-2.16,4.82-4.82,4.82h-8.97c-2.66,0-4.82-2.16-4.82-4.82v-7.58c0-2.66,2.16-4.82,4.82-4.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.92,53.57c-1.63-1.9-3.96-2.98-6.41-2.98h-52.2c-4.73,0-8.57,3.98-8.57,8.87v31.96c0,4.89,3.85,8.87,8.57,8.87h47.24c4.23,0,7.79-3.14,8.46-7.47l4.96-31.96c.41-2.64-.34-5.3-2.05-7.29Zm-11.37,42.85h-47.24c-2.59,0-4.7-2.24-4.7-5v-31.96c0-2.76,2.11-5,4.7-5h52.2c1.34,0,2.57.58,3.48,1.63.98,1.14,1.4,2.67,1.16,4.18l-4.96,31.96c-.38,2.43-2.33,4.19-4.64,4.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandVan);
export default __webpack_public_path__ + "static/media/SandVan.52e88df01a1f76de91afbdb67180886c.svg";
export { ForwardRef as ReactComponent };